<div class="step-pagamento space-y-6">
  <div class="flex justify-between items-center">
    <span class="text-sm font-medium text-gray-700">Total informado: {{ totalPaidFormatted }}</span>
    <p-button
      label="Adicionar forma de pagamento"
      icon="pi pi-plus"
      severity="secondary"
      (click)="addPayment()"
    ></p-button>
  </div>

  <div class="bg-white shadow rounded overflow-x-auto" [formGroup]="parentForm">
    <div formArrayName="payments">
      <p-table
        [value]="paymentsArray.controls"
        [paginator]="false"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Forma de pagamento</th>
            <th class="text-left px-6 py-3">Valor</th>
            <th class="text-left px-6 py-3" style="width: 80px;">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr [formGroupName]="i" [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 align-middle">
              <p-dropdown
                formControlName="typePaymentId"
                [options]="typePaymentOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                appendTo="body"
                class="w-full"
              ></p-dropdown>
            </td>
            <td class="px-6 py-2 align-middle">
              <p-inputNumber
                formControlName="value"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                class="w-full"
              ></p-inputNumber>
            </td>
            <td class="px-6 py-2 align-middle">
              <p-button
                icon="pi pi-trash"
                [text]="true"
                severity="danger"
                (click)="removePayment(i)"
                [disabled]="paymentsArray.length <= 1"
                pTooltip="Remover"
              ></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center py-8 text-gray-500">
              Nenhuma forma de pagamento. Clique em &quot;Adicionar forma de pagamento&quot;.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
